'use client';

import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

type ScrollToTopProps = {
    scrollRef: React.RefObject<HTMLDivElement | null>;
};

const ScrollToTop = ({ scrollRef }: ScrollToTopProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {

    
    const scrollContainer = scrollRef.current;

    
    if (!scrollContainer) return;

    const toggleVisibility = () => {
      setIsVisible(scrollContainer.scrollTop > 300);
    };

    scrollContainer.addEventListener('scroll', toggleVisibility);
    return () => scrollContainer.removeEventListener('scroll', toggleVisibility);
  }, [scrollRef]);

  const scrollToTop = () => {
    scrollRef.current?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-3 right-[30px] z-50 p-3 rounded-full bg-[#f17c06] text-white shadow-lg hover:bg-[#f17c06] transition-opacity duration-300 ${
        isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default ScrollToTop;
